(ns ycweb.app.website.help.article
  (:require
   [rum.core :as rum]
   [ycweb.app.website.website :as website]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.help.common :as common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.scroll :as scroll]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc help-article-view < rum/reactive [app-atom {:keys [article table-of-contents]}]
  (let [content-count (count table-of-contents)]
    [:div
     {:class (u/bem :yc-section [:medium-underline])}
     (cond
       (:body article)
       [:<>
        [:div.u-block-center.u-max-width-720
         (headings/heading (:title article)
           {:type :h1
            :size :large
            :center true})]

        (when (>= content-count 3)
          [:nav.help-center-article-nav.u-block-center.u-max-width-720
           [:ul
            {:class (u/bem :yc-list [:flush])}
            (map
              (fn [{:table-contents/keys [id head-tag]}]
                [:li
                 [:a.text-link
                  (urlstate/href-on-click #(scroll/scroll-to-id % (str "heading" id)))
                  [:span {:dangerouslySetInnerHTML {:__html head-tag}}]]])
              table-of-contents)]])
        (:body article)]

       :else
       [:<>
        [:div.help-center-article.yc-simple-text.u-block-center.u-max-width-720
         (headings/heading "Sorry, this article is no longer available"
           {:type :h1
            :size :large
            :center true})]
        [:div.help-center-article.yc-simple-text.u-block-center.u-max-width-720
         [:p
          "This article is no longer available. It's likely that the article was for a promotion that has since ended, or simply content that is no longer relevant or that has been moved to another FAQs category. If there's something specific you were looking for but now can't find, please reach out to our "
          [:a (urlstate/href-props app-atom "help") "customer support team"]]]])
     (toaster/loading-overlay app-atom :web.help/article)]))

(rum/defc article-page < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        help-atom (rum/cursor process-atom :help-article)
        {:help-article/keys [id body category table-contents]} (rum/react help-atom)
        {:ent/keys [display-name]} (rum/react help-atom)]
    (web-common/set-meta-title!
      (str "Yuppiechef Help - FAQs - " (:ent/display-name category) " - " display-name))
    [:div
     (common/help-center-banner app-atom {})
     (common/breadcrumbs app-atom
       {:id (:category/id category)
        :display-name (:ent/display-name category)
        :url-name (:category/url-name category)})
     (help-article-view app-atom
       {:article
        {:title display-name
         :body
         [:div.help-center-article.u-block-center.yc-simple-text.u-max-width-720.js-mfp-spa-body
          {:dangerouslySetInnerHTML {:__html body}
           :style {:position :relative}}]}
        :table-of-contents table-contents})

     (when
       (and
         (cmn/has-permission? app-atom "SiteAdmin:Help Center")
         (not (cmn/curact app-atom [:mobile?])))
       [:div
        {:class (u/bem :yc-section [:medium])}
        [:div.u-block-center.u-max-width-720.u-margin-top-40.u-text-center
         (buttons/button-web "Edit Article in Backend"
           (merge
             (urlstate/href-props app-atom "admin/help" "editarticle" {:id id})
             {:target "_blank"
              :style :secondary
              :size :default}))]])
     [:div
      {:class (u/bem :yc-section [:large])}
      (common/help-center-footer app-atom)]]))

(defmethod flow/render-screen :web.help/article [app-atom _]
  (website/screen-wrapper app-atom
    (article-page app-atom)
    {:pagetype :help
     :hidesearch true}))

(defmethod t/transition-open :web.help/article [app-atom _ {:keys [id]}]
  (let [user-id (cmn/curact app-atom [:user :refid])]
    (toaster/open-overlay app-atom :web.help/article)
    (comms/ajax-get :web.help/article
      {:help-article
       #:help-article
        {:id id
         :user-id user-id}})))

(defmethod comms/receive :web.help/article [app-atom {:keys [help-article]}]
  (cond
    (nil? help-article)
    (urlstate/redirect app-atom "help" "")

    :else
    (swap! (cmn/process-cursor app-atom) assoc
      :help-article help-article))
  (toaster/close-overlay app-atom :web.help/article))

;; ========= Help Article Modal ===========================
;; Opens a help article inline in a modal (mirrors the legacy
;; js-mfp-open-url behaviour) instead of navigating to the full page.

(rum/defc help-article-modal-body < rum/reactive [app-atom]
  (let [article (cmn/curact (cmn/process-cursor app-atom) [:help-article])
        body (:help-article/body article)]
    [:div.modal__content
     {:style {:position "relative" :min-height "120px"}}
     (when-let [title (:ent/display-name article)]
       (headings/heading title {:type :h2 :size :small}))
     (when body
       [:div.help-center-article.yc-simple-text
        {:dangerouslySetInnerHTML {:__html body}}])
     (toaster/loading-overlay app-atom :web.help/article)]))

(defmethod grid/modal-config :web.help/article-modal [_ _ _]
  {:body-raw help-article-modal-body
   :modal-type :variable})

(defn open-article-modal [app-atom {:keys [id]}]
  (grid/open-modal app-atom :web.help/article-modal {:config {:max-width 720}})
  (toaster/open-overlay app-atom :web.help/article)
  (comms/ajax-get :web.help/article
    {:help-article
     #:help-article
      {:id id
       :user-id (cmn/curact app-atom [:user :refid])}}))

(defn article-modal-props
  "href + on-click that open the given help article in a modal, falling back
   to the full help page if JS is unavailable."
  [app-atom {:keys [id] article-name :name}]
  {:href (str "/help.htm?action=article&id=" id (when article-name (str "&name=" article-name)))
   :on-click
   (fn [e]
     #?(:cljs (.preventDefault e))
     (open-article-modal app-atom {:id id}))})
